export default [
  {
    component: 'CNavItem',
    name: 'Start',
    to: '/start',
    icon: 'cil-speedometer',
    badge: {
      color: 'primary',
      text: 'Admin',
    },
  },
  {
    component: 'CNavItem',
    name: 'Lista klientów',
    to: '/crm/customer',
    icon: 'cil-address-book',
  },
  {
    component: 'CNavItem',
    name: 'Lista inwestycji',
    to: '/crm/investment',
    icon: 'cil-industry',
  },
  {
    component: 'CNavItem',
    name: 'Lista ofert',
    to: '/crm/project',
    icon: 'cil-task',
  }, 
  //{
  //  component: 'CNavItem',
  //  name: 'Sprzęt na stanie',
  //  to: '/jmp/parkMaszynowy',
  //  icon: 'cil-garage',
  //},
  //{
  //  component: 'CNavItem',
  //  name: 'Sprzęt na wynajmnie',
  //  to: '/jmp/parkMaszynowyW',
  //  icon: 'cil-share-alt',
  //},
  //{
  //  component: 'CNavItem',
  //  name: 'Wózki sprzedane',
  //  to: '/jmp/parkMaszynowyL',
  //  icon: 'cil-car-alt',
  //},
  //{
  //  component: 'CNavItem',
  //  name: 'Zlecenia serwisowe',
  //  to: '/jmp/zleceniaWarsztatowe',
  //  icon: 'cil-task',
  //},
  //{
  //  component: 'CNavItem',
  //  name: 'Maszyny w naprawie',
  //  to: '/jmp/wNaprawie',
  //  icon: 'cil-paint-bucket',
  //},
  //{
  //  component: 'CNavItem',
  //  name: 'Lista części',
  //  to: '/jmp/zleceniaCzesci',
  //  icon: 'cil-memory',
  //},
  {
    component: 'CNavGroup',
    name: 'Raporty',
    to: '/base',
    icon: 'cil-print',
    items: [
      {
        component: 'CNavItem',
        name: 'Raport 1',
        to: '/dev/working',
      },
      {
        component: 'CNavItem',
        name: 'Raport 2',
        to: '/dev/working',
      },
      {
        component: 'CNavItem',
        name: 'Raport 3',
        to: '/dev/working',
      },
      {
        component: 'CNavItem',
        name: 'Raport 4',
        to: '/dev/working',
      },
    ]
  },
  /*
  {
    component: 'CNavTitle',
    name: 'Serwis',
  },
  {
    component: 'CNavItem',
    name: 'Nowa naprawa',
    to: '/jmp/service',
    icon: 'cil-cog',
  },
  {
    component: 'CNavItem',
    name: 'Serwis mobilny',
    to: '/jmp/zleceniaSerwisowe',
    icon: 'cil-cloudy',
  },
  {
    component: 'CNavItem',
    name: 'Historia',
    to: '/dev/working',
    icon: 'cil-history',
  },
  {
    component: 'CNavTitle',
    name: 'Wynajem',
  },
  {
    component: 'CNavItem',
    name: 'Nowy wpis',
    to: '/dev/working',
    icon: 'cil-external-link',
  },
  //{
  //  component: 'CNavItem',
  //  name: 'Historia',
  //  to: '/dev/working',
  //  icon: 'cil-history',
  //},
  {
    component: 'CNavTitle',
    name: 'Magazyn',
  },
  {
    component: 'CNavItem',
    name: 'Lista części',
    to: '/dev/working',
    icon: 'cil-memory',
  },
  {
    component: 'CNavTitle',
    name: 'Sprzedaż',
  },
  
  {
    component: 'CNavItem',
    name: 'Dostawa',
    to: '/dev/working',
    icon: 'cil-industry',
  },
  */

  {
    component: 'CNavTitle',
    name: 'Konfiguracja',
  },
  {
    component: 'CNavItem',
    name: 'Zmień hasło',
    to: '/jmp/changePassword',
    icon: 'cil-shield-alt',
  },
  {
    component: 'CNavItem',
    name: 'Użytkownicy',
    to: '/jmp/users',
    icon: 'cil-user-plus',
  },
  {
    component: 'CNavItem',
    name: 'Dane Porównywarki',
    to: '/crm/porownywarka',
    icon: 'cil-memory',
  },
  //{
  //  component: 'CNavItem',
  //  name: 'Listy kontrolne',
  //  to: '/jmp/listaCzynnosci',
  //  icon: 'cil-task',
  //}
  /*,
  {
    component: 'CNavItem',
    name: 'Colors',
    to: '/theme/colors',
    icon: 'cil-drop',
  },
  {
    component: 'CNavItem',
    name: 'Typography',
    to: '/theme/typography',
    icon: 'cil-pencil',
  },
  {
    component: 'CNavTitle',
    name: 'Components',
  },
  {
    component: 'CNavGroup',
    name: 'Base',
    to: '/base',
    icon: 'cil-puzzle',
    items: [
      {
        component: 'CNavItem',
        name: 'Accordion',
        to: '/base/accordion',
      },
      {
        component: 'CNavItem',
        name: 'Breadcrumbs',
        to: '/base/breadcrumbs',
      },
      {
        component: 'CNavItem',
        name: 'Cards',
        to: '/base/cards',
      },
      {
        component: 'CNavItem',
        name: 'Carousels',
        to: '/base/carousels',
      },
      {
        component: 'CNavItem',
        name: 'Collapses',
        to: '/base/collapses',
      },
      {
        component: 'CNavItem',
        name: 'List Groups',
        to: '/base/list-groups',
      },
      {
        component: 'CNavItem',
        name: 'Navs & Tabs',
        to: '/base/navs',
      },
      {
        component: 'CNavItem',
        name: 'Paginations',
        to: '/base/paginations',
      },
      {
        component: 'CNavItem',
        name: 'Placeholders',
        to: '/base/placeholders',
      },
      {
        component: 'CNavItem',
        name: 'Popovers',
        to: '/base/popovers',
      },
      {
        component: 'CNavItem',
        name: 'Progress',
        to: '/base/progress',
      },
      {
        component: 'CNavItem',
        name: 'Spinners',
        to: '/base/spinners',
      },
      {
        component: 'CNavItem',
        name: 'Tables',
        to: '/base/tables',
      },
      {
        component: 'CNavItem',
        name: 'Tooltips',
        to: '/base/tooltips',
      },
    ],
  },
  {
    component: 'CNavGroup',
    name: 'Buttons',
    to: '/buttons',
    icon: 'cil-cursor',
    items: [
      {
        component: 'CNavItem',
        name: 'Buttons',
        to: '/buttons/standard-buttons',
      },
      {
        component: 'CNavItem',
        name: 'Button Groups',
        to: '/buttons/button-groups',
      },
      {
        component: 'CNavItem',
        name: 'Dropdowns',
        to: '/buttons/dropdowns',
      },
    ],
  },
  {
    component: 'CNavGroup',
    name: 'Forms',
    to: '/forms',
    icon: 'cil-notes',
    items: [
      {
        component: 'CNavItem',
        name: 'Form Control',
        to: '/forms/form-control',
      },
      {
        component: 'CNavItem',
        name: 'Select',
        to: '/forms/select',
      },
      {
        component: 'CNavItem',
        name: 'Checks & Radios',
        to: '/forms/checks-radios',
      },
      {
        component: 'CNavItem',
        name: 'Range',
        to: '/forms/range',
      },
      {
        component: 'CNavItem',
        name: 'Input Group',
        to: '/forms/input-group',
      },
      {
        component: 'CNavItem',
        name: 'Floating Labels',
        to: '/forms/floating-labels',
      },
      {
        component: 'CNavItem',
        name: 'Layout',
        to: '/forms/layout',
      },
      {
        component: 'CNavItem',
        name: 'Validation',
        to: '/forms/validation',
      },
    ],
  },
  {
    component: 'CNavItem',
    name: 'Charts',
    to: '/charts',
    icon: 'cil-chart-pie',
  },
  {
    component: 'CNavGroup',
    name: 'Icons',
    to: '/icons',
    icon: 'cil-star',
    items: [
      {
        component: 'CNavItem',
        name: 'CoreUI Icons',
        to: '/icons/coreui-icons',
        badge: {
          color: 'info',
          text: 'NEW',
        },
      },
      {
        component: 'CNavItem',
        name: 'Brands',
        to: '/icons/brands',
      },
      {
        component: 'CNavItem',
        name: 'Flags',
        to: '/icons/flags',
      },
    ],
  },
  {
    component: 'CNavGroup',
    name: 'Notifications',
    to: '/notifications',
    icon: 'cil-bell',
    items: [
      {
        component: 'CNavItem',
        name: 'Alerts',
        to: '/notifications/alerts',
      },
      {
        component: 'CNavItem',
        name: 'Badges',
        to: '/notifications/badges',
      },
      {
        component: 'CNavItem',
        name: 'Modals',
        to: '/notifications/modals',
      },
    ],
  },
  {
    component: 'CNavItem',
    name: 'Widgets',
    to: '/widgets',
    icon: 'cil-calculator',
    badge: {
      color: 'primary',
      text: 'NEW',
      shape: 'pill',
    },
  },
  {
    component: 'CNavTitle',
    name: 'Extras',
  },
  {
    component: 'CNavGroup',
    name: 'Pages',
    to: '/pages',
    icon: 'cil-star',
    items: [
      {
        component: 'CNavItem',
        name: 'Login',
        to: '/pages/login',
      },
      {
        component: 'CNavItem',
        name: 'Register',
        to: '/pages/register',
      },
      {
        component: 'CNavItem',
        name: 'Error 404',
        to: '/pages/404',
      },
      {
        component: 'CNavItem',
        name: 'Error 500',
        to: '/pages/500',
      },
    ],
  },*/

  // {
  //   component: 'CNavItem',
  //   name: 'Download CoreUI',
  //   href: 'http://coreui.io/vue/',
  //   icon: { name: 'cil-cloud-download', class: 'text-white' },
  //   _class: 'bg-success text-white',
  //   target: '_blank'
  // },
  // {
  //   component: 'CNavItem',
  //   name: 'Try CoreUI PRO',
  //   href: 'http://coreui.io/pro/vue/',
  //   icon: { name: 'cil-layers', class: 'text-white' },
  //   _class: 'bg-danger text-white',
  //   target: '_blank'
  // }
]
